import { subGruboFilterTipoTroca } from './tipoTrocaSubgrupo';

const condicaoGeralPlanotipoMensalidade = (tipoFrequenciaPagamento, resultado) => {
    const zero = 0;

    if(tipoFrequenciaPagamento == 'A' && resultado.length > zero ) {
        return resultado.filter(e => e.plano.includes('A'));
    }

    if(tipoFrequenciaPagamento == 'AT' && resultado.length > zero ) {
        return resultado.filter(e => e.plano.includes('4'));
    }

    if(tipoFrequenciaPagamento == 'M' && resultado.length > zero ) {
        return resultado.filter(e => (
            e.plano.includes('4') || 
            e.plano.includes('A')) === false || 
            e.plano?.trim() ==='ZTA' 
        );
    } else {
        return resultado;
    }
};

const filtroRetiraSubgrupoTroca = (value, grupoRegiao) => {
    if(value.TipoVenda !== 'TROCA'){        
        return grupoRegiao.filter(
            element =>
                element.plano.trim() !=
                'ZTT' &&
                element.plano.trim() !=
                'ZFTC' &&
                element.plano.trim() !=
                'ZFT' &&
                element.plano.trim() !=
                'ZTA' &&
                element.plano.trim() !=
                'ZSMT' &&
                element.plano.trim() !=
                'ZSMTC'
        );       
    } else {        
        return grupoRegiao;
    }
};

export const  condicaoPlanotipoMensalidade = (grupoRegiao, tipoFrequenciaPagamento, value) => {
    let resultado = grupoRegiao.filter(
        element =>
            element.plano.trim() !=
            'ZT' &&
            element.plano.trim() !=
            'ZTC'
    );

    resultado = filtroRetiraSubgrupoTroca(value, grupoRegiao);  

    const resultadoAposCondicao = condicaoGeralPlanotipoMensalidade(tipoFrequenciaPagamento, resultado);

    const resultadoAposCondicaoAtivos =  resultadoAposCondicao.filter(plano => plano.status);

    return resultadoAposCondicaoAtivos;
};

export const condicaoPlanotipoMensalidadeM65 = (grupoRegiao, value, tipoFrequenciaPagamento ) => {
    let resultado = grupoRegiao.filter(subGrp => !subGrp.troca && subGrp.plano?.trim() !== 'ZTA');

    resultado = filtroRetiraSubgrupoTroca(value, grupoRegiao);

    if(value.TipoVenda === 'TROCA'){        
        resultado = subGruboFilterTipoTroca(grupoRegiao);       
    }

    const resultadoAposCondicao = condicaoGeralPlanotipoMensalidade(tipoFrequenciaPagamento, resultado);

    const resultadoAposCondicaoAtivos =  resultadoAposCondicao.filter(plano => plano.status);

    return resultadoAposCondicaoAtivos;
};
